import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "@/core/services/store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueCookies from "vue-cookies";
import jQuery from "jquery";

// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";
// import "toastr/build/toastr.min.css";
import ApiService from "@/core/services/api.service";
import { IS_AUTH } from "@/core/services/store/auth.module";
import i18n from "@/core/plugins/vue-i18n";
import mixins from "./mixins";
import VueGtag from "vue-gtag";

import Autocomplete from "@trevoreyre/autocomplete-vue";
import "@trevoreyre/autocomplete-vue/dist/style.css";
import "./assets/ex-theme.css";

document.body.classList.add("site-" + process.env.VUE_APP_APP_WEBSITE);

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(Autocomplete);

Vue.config.productionTip = false;
Vue.prototype.$translate = i18n;
Vue.prototype.$eventHub = new Vue();
Vue.prototype.$ = jQuery;
window.$ = jQuery;

// API service init
ApiService.init();
Vue.mixin(mixins);
Vue.use(
    VueGtag,
    {
        config: { id: "G-W87EN1R854" }
    },
    router
);

import VuePhoneNumberInput from "vue-phone-number-input";

Vue.component("vue-phone-number-input", VuePhoneNumberInput);

ApiService.get(`/system/languages`).then(response => {
    localStorage.setItem("langs", JSON.stringify(response.data));
    for (const item in response.data) {
        ApiService.get(`/translation/${item}`).then(resp => {
            i18n.setLocaleMessage(item, resp.data);
        });
    }
});

let siteLockChecked = false;
let isSiteLocked = false;

router.beforeEach((to, from, next) => {
    // Scroll page to top on every route change
    setTimeout(() => {
        // window.scrollTo(0, 0);
    }, 100);

    if (to.name === "Locked") {
        next();
        return;
    }

    const performAuthCheck = () => {
        if (to.meta.auth) {
            Promise.all([store.dispatch(IS_AUTH)])
                .then(resp => {
                    if (resp[0]) {
                        next();
                    } else {
                        router.push({ name: "Home" });
                    }
                })
                .catch(() => {
                    router.push({ name: "Home" });
                });
        } else {
            next();
        }
    };

    if (!siteLockChecked) {
        let code = "";
        try {
            const tokenStr = localStorage.getItem("site_access_token");
            if (tokenStr) {
                const tokenObj = JSON.parse(tokenStr);
                if (tokenObj.expiry > new Date().getTime()) {
                    code = tokenObj.code;
                } else {
                    localStorage.removeItem("site_access_token");
                }
            }
        } catch (e) {
            // ignore
        }

        ApiService.query("/system/check-lock", {
            headers: { "X-Site-Access-Code": code }
        })
            .then(resp => {
                siteLockChecked = true;
                if (resp.data.locked) {
                    isSiteLocked = true;
                    next({ name: "Locked" });
                } else {
                    isSiteLocked = false;
                    performAuthCheck();
                }
            })
            .catch(() => {
                siteLockChecked = true;
                isSiteLocked = false;
                performAuthCheck();
            });
    } else {
        if (isSiteLocked) {
            next({ name: "Locked" });
        } else {
            performAuthCheck();
        }
    }
});

new Vue({
    router,
    store,
    i18n,
    VueCookies,
    render: h => h(App)
}).$mount("#app");
